/**
 * Simple tab state for V2 pager.
 * No transition lock needed — the strip approach handles everything via MotionValue.
 */
import { useCallback, useState } from 'react';

export const TABS = ['buxbox', 'mybux', 'roxbox'] as const;
export type TabId = (typeof TABS)[number];

export function useV2TabMachine(initial: TabId = 'buxbox') {
  const [activeTab, setActiveTab] = useState<TabId>(initial);
  const activeIndex = TABS.indexOf(activeTab);

  const requestTab = useCallback((id: TabId) => {
    setActiveTab(id);
  }, []);

  const setTabByIndex = useCallback((index: number) => {
    if (index >= 0 && index < TABS.length) {
      setActiveTab(TABS[index]);
    }
  }, []);

  return { activeTab, activeIndex, requestTab, setTabByIndex };
}
